import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/error.tsx");
